import React from 'react';
import { Col, Row } from 'react-bootstrap';
import './AuthBrandPanel.css';

const BRAND_LINE_SIZES = ['lg', 'md', 'sm'];

const AuthBrandPanel = ({ tagline }) => (
  <Col xs={12} sm={12} md={6} lg={7} className="auth-brand d-none d-md-flex p-3 p-md-4 p-lg-5">
    <Row className="auth-brand-inner g-0 w-100">
      <Col xs={12} sm={12} md={12} lg={12}>
        <Row className="auth-brand-lines g-0 align-items-center">
          {BRAND_LINE_SIZES.map((size) => (
            <Col key={size} xs="auto" className={size === 'sm' ? '' : 'pe-2'}>
              <span className={`auth-brand-line auth-brand-line--${size}`} />
            </Col>
          ))}
        </Row>
        <p className="auth-brand-sub">{tagline}</p>
      </Col>
    </Row>
  </Col>
);

export default AuthBrandPanel;
